import React from 'react';
import { translate } from 'utlis/translations/i18n';

class SequenceInterludePagination extends React.Component {
    render() {
        const { sessionInstance, className = '', interludes } = this.props;
        const { currentSequenceInterlude } = sessionInstance;

        return (
            <div className={"sequence-pagination-wrapper " + className}>
                <div className="pagination">
                    <span className="muted">{translate('interlude')}</span> {currentSequenceInterlude + 1} <span className="muted">{translate('of')}</span> {interludes.length}
                </div>
            </div>
        );
    }
}
export default SequenceInterludePagination;